<template>
  <div class="root">
    <header>
      <div class="logo">
        <a href="http://s.noc.net.cn/" target="_blank" class="head-logo">
          <img src="./images/logo.png">
        </a>
        <span class="head-title">2023-2024学年全国中小学信息技术创新与实践大赛<br/>软件创意编程赛项</span>
      </div>
      <ul class="menu">
        <div v-for="(item, index) in activeMenus" :key="index" :style="{display:'inline-block'}">
          <li :class="{active: activeIndex === index}" v-if="index<5"
              @click="changeMenu(index)"><a >{{ item.name }}</a></li>
        </div>
      </ul>
      <div class="login-box">
        <p v-if="userInfo.compCode" @click="logoutShow = true" @mouseleave="logoutShow = false">
          <i class="el-icon-user-solid"></i> 
          <span class="user-name">{{userInfo.competitorOne}}</span>
          <span class="logout"><a v-if="logoutShow" @click="logoutDialogVisible = true">退出</a></span>
        </p>
        <a v-else @click="loginBtn">登录</a>
      </div>
    </header>
    <template>
      <page-info v-if="activeIndex === 2" :imgUrl="nocInfo.infoImg"></page-info>
      <main-form v-else-if="activeIndex === 3"></main-form>
      <div v-else class="content">
        <sign-info-noc v-if="activeIndex === 1"></sign-info-noc>
      </div>
      <login v-if="loginBoxShow" :loginBoxShow.sync="loginBoxShow" @loginBoxHide="loginBoxShow=false" />
      <el-dialog
        :visible.sync="logoutDialogVisible"
        width="30%"
        title="退出登录"
        center>
        <span>您确定要退出登录吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="logOut">确 认</el-button>
        </span>
      </el-dialog>
      <UnloginToast v-if="showUnloginToast" :toastValue="toastValue" @hideUnloginToast="showUnloginToast=false"/>
      <TimeCheckDialog :timeDialogVisible.sync="timeDialogVisible" />
    </template>
  </div>
</template>

<script>
import signInfoNoc from './user-info-noc'
import PageInfo from "./page-info";
import MainForm from './main-form'
import Login from './login'
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import {Dialog, Button } from 'element-ui'
import UnloginToast from './unlogin-toast.vue';
import TimeCheckDialog from './computer-time-dialog.vue';
import { getCurrentTimestamp } from '@/services/noc.js'

export default {
  components: {
    signInfoNoc,
    PageInfo,
    MainForm,
    Login,
    ElButton: Button,
    ElDialog: Dialog,
    UnloginToast,
    TimeCheckDialog,
  },
  data() {
    return {
      showLoginDialog: true,
      modifyForms: false,
      staticMeu: [{ name: '首页' }, { name: '报名查询' }, { name: '步骤流程' }],
      logoutShow: false,
      logoutDialogVisible: false,
      showUnloginToast: false,
      toastValue: '',
      loginBoxShow: false,
      gradeAllOptions: [],
      registerStatus: null,
      competitionStatus: 0, // 0-未请求接口，1-竞赛未开始，2-竞赛已开始
      timeDialogVisible: false
    };
  },
  computed:{
    ...mapState({
      userInfo: state => state.user.userInfo,
      activeIndex: state => state.user.activeIndex,
      nocInfo: state => state.user.nocInfo,
      refreshState: state => state.user.refreshState,
    }),
    ...mapGetters(['isPreliminary', 'isPreliminaryResult', 'isIntermediary', 'isIntermediaryResult']),
    currentGroup() { // 根据组别和语言筛选当前用户所在的组别
      let info = {}
      const { language, group: _group } = this.userInfo
      if (this.nocInfo.language) {
        this.nocInfo.language.some((item) => {
          if (item.name === language) {
            item.groups.some((group) => {
              if (group.name === _group) {
                info = group
                return true
              }
            })
          }
        })
      }
      return info
    },
    activeMenus() {
      if (this.isPreliminaryResult && !this.isPreliminary) {
        // 初赛结果出来且未晋级
        if (this.activeIndex === 3) {
          this.setActiveIndex(1)
        }
        return [...this.staticMeu]
      }
      if (this.isIntermediaryResult && !this.isIntermediary) {
        // 复赛结果出来且未晋级
        if (this.activeIndex === 3) {
          this.setActiveIndex(1)
        }
        return [...this.staticMeu]
      }
      if (this.currentGroup.hideMenu === true) {
        if (this.activeIndex === 3) {
          this.setActiveIndex(1)
        }
        return [...this.staticMeu]
      }
      return [...this.staticMeu, { name: '比赛平台' }]
    }
  },
  async mounted() {
    this.$store.dispatch('initUserInfo')
    this.getNocInfoInterval()
    this.getExamList()
    this.checkTime()
  },
  beforeDestroy () {
    clearInterval(this.inter)
    clearInterval(this.inter2)
  },
  methods: {
    ...mapActions(['LogOut','setActiveIndex','setModifyStatus', 'getNocInfo', 'getExamList']),
    ...mapMutations(['setMenuData']),
    loginBtn() {
      this.$router.push('/login')
      this.logoutShow = false
    },
    logOut(){
      this.LogOut()
    },

    changeMenu(key) {
      if(key == 0) {
        window.open('http://s.noc.net.cn')
        return
      }
      this.setModifyStatus(false)
      this.setActiveIndex(key)
      if(!this.userInfo.compCode) {
        this.$router.push({path: '/login'})
      }
    },
    // 用户电脑时间校验
    handleLocalTimeCheck(serviceTime) {
      this.timeDialogVisible = Math.abs(new Date().getTime() - serviceTime) >= 2 * 60 * 1000
    },
    async checkTime() {
      const { data } = await getCurrentTimestamp()
      this.handleLocalTimeCheck(data)
      this.inter = setInterval(async () => {
        const { data } = await getCurrentTimestamp()
        this.handleLocalTimeCheck(data)
      }, 1000 * 60 * 5)
    },
    async getNocInfoInterval() {
      await this.getNocInfo()
      this.inter2 = setInterval(() => {
        this.getNocInfo()
      }, 10000)
    }
  },
  watch:{
  }
}
</script>
<style>
body {
  background-color: #eee;
}
</style>
<style lang="less" scoped>
.root {
  width: 100%;
  text-align: center;
  height: 100%;

  .competition-tip {
    padding-top: 50px;
    font-size: 20px;
    color: #333;
    line-height: 40px;
  }
  header {
    text-align: left;
    font-family: Microsoft Yahei;
    width: 100%;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 1px 5px 0px;
    background: rgb(12, 131, 220, 1);
    z-index: 100;
    color: #fff;
    display: flex;
    justify-content: space-between;
    -webkit-box-align: center;
    align-items: center;
    height: 64px;
    position: sticky;
    top: 0px;

    .logo {
      float: left;
      min-width: 240px;

      .head-logo img {
        width: 55px;
        vertical-align: middle;
        padding: 7px 10px 0px;
      }

      .head-title {
        order: 1;
        width: 380px;
        display: inline-block;
        padding-top: 8px;
        float: right;
        line-height: 20px;
        text-align: center;
      }
    }

    .menu {
      flex: 0 0 600px;
      background: transparent;

      li {
        cursor: pointer;
        display: inline-block;
        color: #fff;
        font-size: 18px;
        font-weight: 400;
        width: 112px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        text-decoration: none;

        &:hover, &.active {
          background: transparent;
          color: #FFB500;
          border-bottom: 2px solid #FFB500;
        }
      }
    }

    .login-box {
      flex: 0 0 160px;
      font-size: 18px;
      font-weight: 400;

      p {
        position: relative;
        height: 64px;
        
        min-width: 80px;
        text-align: center;
        cursor: pointer;
        display: inline-block;
        i {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: 12px;
          color: #ddd;
          font-size: 18px;
        }
        .user-name{
          display: inline-block;
          font-size: 16px;
          max-width: 115px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          line-height: 64px;
          position: relative;
          top: 13px;
        }
        .logout {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: 60px;
          line-height: normal;
          padding-top: 10px;
          a {
            background-color: #fff;
            border-radius: 20px;
            width: 80px;
            line-height: 40px;
            height: 40px;
            color: #333;
            padding: 0;
            text-align: center;
            font-size: 16px;
          }
        }
      }
      a {
        display: inline-block;
        padding: 20px 20px;
      }
    }
  }

  .content {
    text-align: left;
    width: 80%;
    min-width: 1140px;
    min-height: calc(100% - 185px);
    background-color: #fff;
    margin: 50px 0 70px;
    display: inline-block;
    border-radius: 5px;
    box-shadow: 0 0 5px #ddd;
    padding-bottom: 20px;
    position: relative;
  }

  iframe {
    width: 100%;
    height: 100%;
  }
}


@media screen and (max-width: 1200px) {
  body {
    width: 1400px;
  }

  .root {
    width: 1300px;
  }

  body .head-title {
    order: 1;
    width: 200px;
    display: inline-block;
    float: right;
    padding-top: 0;
  }
}

@media screen and  (max-width: 1500px) {
  body .head-title {
    order: 1;
    width: 200px;
    display: inline-block;
    float: right;
    padding-top: 0;
  }
}
</style>